import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import ContentCopy from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetPartnersHandler } from '../dataHandlers/getPartnersHandler';
import PartnerActionMenu from './PartnerActionMenu';

export default function PartnersTable({
  handlePaginationChange,
  searchQuery = {},
  paginationModel = { page: 0, pageSize: 10 },
}) {
  const { partners, totalDocuments, isLoading } = useGetPartnersHandler({ searchQuery });

  const handleCopyId = async (value) => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
    } catch (error) {
      // Ignore clipboard errors to avoid blocking table interactions.
    }
  };

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
      renderCell: (params) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: '100%', height: '100%' }}
        >
          <Typography
            variant="body2"
            title={params.value || '-'}
            sx={{
              minWidth: 0,
              flexGrow: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {params.value || '-'}
          </Typography>
          <Tooltip title="Copy ID">
            <span>
              <IconButton
                size="small"
                color="primary"
                sx={{ ml: 0.5, flexShrink: 0 }}
                aria-label={`copy-${params.value || 'id'}`}
                disabled={!params.value}
                onClick={(event) => {
                  event.stopPropagation();
                  handleCopyId(params.value);
                }}
              >
                <ContentCopy fontSize="inherit" />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      ),
    },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'is_embedded', headerName: 'Embedded', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      renderCell: (params) => <PartnerActionMenu partner={params.row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={partners}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        loading={isLoading}
        paginationModel={paginationModel}
        pageSizeOptions={[10, 25]}
        disableColumnMenu
        disableColumnSorting
        disableColumnFilter
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => handlePaginationChange(model.page, model.pageSize)}
        slots={{ pagination: CustomPagination }}
      />
    </Box>
  );
}
